/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Cve
 */
export interface Cve {
}

/**
 * Check if a given object implements the Cve interface.
 */
export function instanceOfCve(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CveFromJSON(json: any): Cve {
    return CveFromJSONTyped(json, false);
}

export function CveFromJSONTyped(json: any, ignoreDiscriminator: boolean): Cve {
    return json;
}

export function CveToJSON(value?: Cve | null): any {
    return value;
}

